import { NextResponse } from "next/server";

import { addToServerCart } from "@/app/panier/actions";

function getErrorStatus(message: string) {
  switch (message) {
    case "Non autorisé":
      return 401;
    case "Données panier invalides":
    case "Données invalides":
      return 400;
    case "Produit introuvable":
      return 404;
    case "Stock insuffisant":
      return 409;
    default:
      return 500;
  }
}

export async function POST(req: Request) {
  try {
    const body = (await req.json()) as {
      productId?: unknown;
      quantity?: unknown;
    };

    const productId =
      typeof body.productId === "string" ? body.productId.trim() : "";
    const quantity =
      typeof body.quantity === "number"
        ? body.quantity
        : typeof body.quantity === "string"
          ? Number(body.quantity)
          : NaN;

    if (!productId || !Number.isFinite(quantity) || quantity <= 0) {
      return NextResponse.json({ error: "Données invalides" }, { status: 400 });
    }

    await addToServerCart(productId, quantity);

    return NextResponse.json({ ok: true });
  } catch (error) {
    const message =
      error instanceof Error ? error.message : "Erreur serveur";

    console.error("/api/cart/sync", error);

    return NextResponse.json(
      { error: message },
      { status: getErrorStatus(message) },
    );
  }
}